module.exports = __webpack_public_path__ + "media/aviemore-cut.2f57b821.mp3";